import { render, staticRenderFns } from "./ObjectivesList.vue?vue&type=template&id=98c758ea&scoped=true&"
import script from "./ObjectivesList.vue?vue&type=script&lang=js&"
export * from "./ObjectivesList.vue?vue&type=script&lang=js&"
import style0 from "./ObjectivesList.vue?vue&type=style&index=0&id=98c758ea&prod&lang=scss&"
import style1 from "./ObjectivesList.vue?vue&type=style&index=1&id=98c758ea&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c758ea",
  null
  
)

export default component.exports